export default __webpack_public_path__ + "static/media/ZZC_7774.5f2ef4e6.jpg";